import { useEffect, useRef } from 'react';

/**
 * Иногда нужно обойти StrictMode, т.к. вызов коллбека эффекта дважды не всегда допустим.
 * Данный хук позволяет поправить данное недоразумение
 * @param callback
 * @param dependencies
 */
export const useInitialEffect = (callback: () => void, dependencies: unknown[]) => {
    const dependenciesCache = useRef<unknown[] | null>(null);

    useEffect(() => {
        // Если эффект с пустыми зав-ми уже выполнялся
        const emptyDepsEffectWasInited = dependenciesCache.current?.length === 0;
        // Если эффект зависимости этого эффекта совпадают с зависимостями предыдущего выполнения
        const depsMatch = dependenciesCache.current && dependenciesCache.current.every(it => dependencies.includes(it));

        if (emptyDepsEffectWasInited || depsMatch) return;

        dependenciesCache.current = dependencies;

        callback();
    }, dependencies);
};
